<template>
  <div id="new-page">
    <div>
      <table style="margin: 0 auto;margin-top: 20px">
        <tr>
          <td>
            <label>Slug</label>
          </td>
          <td>
            <input type="text" v-model="slug" :disabled="!isNew" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Active</label>
          </td>
          <td>
            <input type="checkbox" id="checkbox" v-model="active" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Locale</label>
          </td>
          <td>
            <select multiple v-model="countries">
              <option value="LT">Lithuania</option>
              <option value="PL">Poland</option>
            </select>
            <select multiple v-model="cities">
              <option value="vilnius">Vilnius</option>
              <option value="kaunas">Kaunas</option>
              <option value="klaipeda">Klaipeda</option>
              <option value="warsaw">Warsaw</option>
            </select>
            <div style="display:inline-block">
              <div>Language</div>
              <select v-model="language">
                <option value="lt">Lithuanian</option>
                <option value="pl">Polish</option>
                <option value="en">English</option>
              </select>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <label>Title</label>
          </td>
          <td>
            <input type="text" v-model="title" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Description</label>
          </td>
          <td>
            <input type="text" v-model="short" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Image</label>
          </td>
          <td>
            <input type="text" v-model="image" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Cover Image</label>
          </td>
          <td>
            <input type="text" v-model="imageCover" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Text</label>
          </td>
          <td>
            <div>Preview: <input type="checkbox" id="checkbox" v-model="preview" style="width: 50px" /></div>
            <textarea v-model="text" v-if="!preview" />
            <MarkdownIt v-if="preview" class="mdown md-body" :content="text" style="width: 400px;text-align:left" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Sort priority</label>
          </td>
          <td>
            <input type="number" v-model="sortPriority" />
          </td>
        </tr>
        <tr>
          <td>
            <label>PN label</label>
          </td>
          <td>
            <input type="text" v-model="label" />
          </td>
        </tr>
        <tr>
          <td>
            <label>PN Button Text</label>
          </td>
          <td>
            <input type="text" v-model="ctaText" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Button Action</label>
          </td>
          <td>
            <input type="text" v-model="ctaScreen" />
          </td>
        </tr>
        <tr>
          <td>
            <label>Date</label>
          </td>
          <td>
            <DatePicker v-model="date" mode="datetime" />
          </td>
        </tr>
      </table>

      <button
        v-on:click="saveNewsUpdate()"
        style="background-color: #333;color: white; padding:10px;cursor:pointer;margin-top:20px;margin-bottom: 30px"
      >Save news update</button>
    </div>
  </div>
</template>

<style scoped lang="less">
#new-page {
  input {
    padding: 10px;
    width: 700px;
  }
  textarea {
    width: 700px;
    height: 500px;
  }
  table {
    td {
      border: 1px solid #999;
      border-collapse: collapse;
      margin: 0;
      padding: 10px;
    }
  }
  .mdown {
    background-color: white;
    padding: 10px;
  }
}
</style>

<script>
import api from "../services/api";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import MarkdownIt from "markdown-it-vue";
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: "home",
  components: { DatePicker, MarkdownIt },
  data: function () {
    return {
      slug: '',
      active: false,
      countries: [],
      cities: [],
      language: 'lt',
      title: '',
      text: '',
      image: '',
      imageCover: '',
      sortPriority: 0,
      label: '',
      ctaScreen: '',
      ctaText: '',
      short: '',
      preview: false,
      date: new Date(),
      isNew: true
    };
  },
  created: async function() {
    // const state = this.$store.state;
    const id = this.$route.params.id;
    this.isNew = id == "new";
    console.log(id);
    if (id) {
      const news = await api.getNews();
      for (let i = 0; i < news.length; i++) {
        if (news[i].id === id) {
          const entry = news[i];
          this.slug = entry.id;
          this.active = entry.active;
          this.countries = entry.countries;
          this.cities = entry.cities;
          this.language = entry.language;
          this.title = entry.title;
          this.text = entry.text;
          this.short = entry.short;
          this.image = entry.image;
          this.imageCover = entry.imageCover;
          this.sortPriority = entry.sortPriority;
          this.ctaScreen = entry.ctaScreen;
          this.ctaText = entry.ctaText;
          this.label = entry.label;
          if (entry.date) {
            this.date = new Date(entry.date._seconds * 1000);
          }
          break;
        }
      }
    }
  },
  methods: {
    saveNewsUpdate: async function () {
      const getEntryData = () => {
        return {
          active: this.active,
          countries: this.countries,
          cities: this.cities,
          language: this.language,
          title: this.title,
          text: this.text,
          short: this.short,
          image: this.image,
          imageCover: this.imageCover,
          sortPriority: this.sortPriority,
          ctaScreen: this.ctaScreen,
          ctaText: this.ctaText,
          label: this.label,
          date: this.date.getTime()
        };
      };
      const data = getEntryData();
      if (this.$route.params.id == "new") {
        await api.createNewsArticle(this.slug, data);
      } else {
        await api.createNewsArticle(this.slug, data);
      }
      this.$router.push({ name: "news" }).catch(() => {});
    },
  },
};
</script>
